/**
 * ReportContentSheet
 *
 * Helper to show the Report Content sheet using SheetService.
 * Matches Flutter implementation:
 * lib/presentation/bottom_sheet/report_content_bottom_sheet.dart
 */

import React from 'react';
import { SheetService } from '@/presentation/components/common/sheet/service/SheetService.index';
import { ReportContentSheetContent } from './components/ReportContentSheetContent';
import type { UserMediaEntity } from '@/domain/entities/userMedia/userMediaEntity';

/**
 * Show the report content sheet
 *
 * @param media - The content being reported
 * @param container - Optional container element or screen key string
 * @param screenKey - Optional screen key of the route opening this sheet
 * @param fixedHeight - Fixed height for the sheet, from responsive.reportContentSheet.fixedHeight
 */
const show = (
  media: UserMediaEntity,
  container?: HTMLElement | string | null,
  screenKey?: string,
  fixedHeight?: string
) => {
  const SheetContent: React.FC = () => {
    return (
      <ReportContentSheetContent
        media={media}
        onFinish={() => SheetService.close()}
      />
    );
  };

  SheetService.show({
    content: <SheetContent />,
    container,
    screenKey,
    fixedHeight,
    dismissible: false,
    closeOnClickOutside: false,
    scrollable: false,
  });
};

export const ReportContentSheet = {
  show,
};
